<template>
  <div class="sort-dropdown form-group">
    <label
      class="sort-dropdown__label text-body-s-bold"
      for="SortBy"
      v-text="$string('general.filter_and_sort.sort_by')"
    />

    <select
      id="SortBy"
      v-model="localCurrentSort"
      class="sort-dropdown__select text-body-s-regular"
      @change="handleChange(localCurrentSort)"
    >
      <option
        v-for="(option) of sortOptions"
        :key="option.value.id"
        :value="option.value"
        v-text="option.title"
      />
    </select>
  </div>
</template>

<script>

/**
 * Vue: Sort dropdown (sort-dropdown)
 * -----------------------------------------------------------------------------
 * Sort dropdown used for collection and search pages.
 *
 * @param {Object} currentSort - Current sort option.
 * @param {Array} sortOptions - Sort options array.
 *
 * @emits handleSort - Emit sort update.
 *
 */

export default {
  name: 'SortDropdown',

  props: {
    currentSort: {
      type: Object,
      default: () => ({}),
    },
    sortOptions: {
      type: Array,
      default: () => [],
    },
  },

  emits: {
    'handle-sort': (payload) => typeof payload === 'object',
  },

  data() {
    return {
      localCurrentSort: {},
    }
  },

  watch: {

    /**
     * Watch sort object to update collection sort.
     */
    currentSort: {
      handler() {
        if (!this.currentSort) {
          return
        }

        this.localCurrentSort = this.currentSort?.value || this.currentSort
      },
      immediate: true,
    },
  },

  mounted() {
    this.localCurrentSort = this.sortOptions[0]?.value
  },

  methods: {

    /**
     * Handle sort change.
     * @param {Object} value - Updated value.
     */
    handleChange(value) {
      this.$emit('handle-sort', value)
    },
  },
}
</script>

<style lang="scss">
@import './sort-dropdown';
</style>
